import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { ROUTES } from '@shared/config/routes';
import { RegisterForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

const { Text } = Typography;

export function RegisterPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('auth.register.title')} subtitle={t('auth.register.subtitle')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <RegisterForm />
        <Text type="secondary" style={{ fontSize: 13, textAlign: 'center' }}>
          {t('auth.register.haveAccount')}{' '}
          <Link to={ROUTES.login}>{t('auth.register.loginLink')}</Link>
        </Text>
      </div>
    </AuthLayout>
  );
}
